const NumberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0
});

const toFormattedNumber = amount => {
  const safeAmount = amount || 0;

  return NumberFormatter.format(safeAmount.toString().replace(/[^0-9.]/g, ''));
};

export default toFormattedNumber;
